import { Col, Container, Image, Row } from 'react-bootstrap';
import IllustrationImage from 'assets/img/landing/ourVision.svg';
import Logo from 'assets/img/landing/monoLogoBig.svg';

function Vision() {
  return (
    <Container fluid className="bg-body-highlight px-lg-14 pb-14">
      <Row className="position-relative">
        <Col lg={2}>
          <p className="fs-4 fw-bold position-lg-absolute bottom-0">
            Our <br /> <span className="text-secondary-light">Visions</span>
          </p>
        </Col>
        <Col lg={8}>
          <Image src={IllustrationImage} alt="illustration" width="100%" />
          <Image
            src={Logo}
            alt="logo"
            className="position-absolute top-0 end-0 d-lg-block d-md-block d-none"
            width={300}
          />
        </Col>
      </Row>
      <Row className="pt-8 d-flex justify-content-end">
        <Col lg={7}>
          <p>
            At Crud Beat, we believe in bridging the gap between talent and
            opportunity. As a premier platform for hiring and training, we
            empower institutions, students, and employers to succeed in today’s
            competitive landscape.
          </p>
        </Col>
        <Col lg={3}>
          <p>
            Our mission is to create a seamless, efficient, and engaging
            experience that transforms potential into excellence.
          </p>
        </Col>
      </Row>
    </Container>
  );
}

export default Vision;
